module.exports = __webpack_public_path__ + "static/media/55_000084.be4da00a.jpg";